import React from "react";
import RestaurantReport from "../AdminPortal/RestaurantReport";

const DMRestaurantReport = () => {
  return <RestaurantReport />;
};

export default DMRestaurantReport;
